export default __webpack_public_path__ + "static/MediaMainBanner-68d04a49a1e2cf92a918400680eacf12.webp";